import {IPostAction} from './IPostAction';
import {IAirBridge} from '../services/IAirBridge';

export class NativePriceAction implements IPostAction {
    constructor(private airBridge: IAirBridge) {
    }

    public execute({offers = [], category = ''}: Record<string, any>): void {
        if (offers.length || category) {
            this.airBridge.evoke(`nativePrice|${category}|${JSON.stringify(offers)}`);
        }
    }
}
